<template>
    <div>
        <card-header title="Registration Documents" icon="fa-id-card"/>
        <card-toolbar>
            <button @click="$openCard('new-reg-document', {registrationId: props.registrationId}, card)"><i class="fas fa-plus mr-2"/>New Document</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <document-list-item
                    :card="card"
                    :doc="doc"
                    v-for="doc in documents"
                    :key="doc.id"
                    :active="(child && child.definition.component === 'edit-reg-document') && child.props.docId === doc.id.toString()"
                    @click="$openCard('edit-reg-document', {registrationId: props.registrationId, docId: doc.id}, card)"
                />
                <container-list-item padded v-if="!documents.length">
                    <p class="has-text-grey is-italic">No documents have been attached to this registration yet.</p>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardToolbar from "../../TIER/components/CardToolbar";
    import CardBody from "../../TIER/components/CardBody";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    import {client as http} from '../../http_client';
    import DocumentListItem from "@/components/DocumentListItem";

    export default {
        name: "RegistrationDocuments",
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, DocumentListItem, CardBody, CardToolbar, CardList, CardHeader},
        data: function() {
            return {
                documents: []
            };
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);
                http.get('/api/registrations/' + this.props.registrationId + '/documents', {force}).then(response => {
                    this.documents = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load(true);
            }
        },
        mounted() {
            this.load(true);
        }
    };
</script>

<style lang="scss" scoped>

</style>
